import React, { PureComponent } from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { connect } from 'react-redux';
import VouchersContent from "./components/VouchersContent";
import { Modal, ModalInputText, ModalText } from '../../business/manage/components/Modal';
import { roleOrLanguageChanged } from "../../../../Utils";
import { url, privateVouchersRequest } from '../../../../Networking';
import Loader from '../../components/Loader';
import NoContent from '../../components/NoContent';
import "./Vouchers.scss";

const EmailVoucher = connect(state => ({ translation: state.translation.vouchers.email }))(class extends PureComponent {
    constructor(props) {
        super(props);
        this.state = { email: props.email, isLoaderVisible: false, isDone: false, isError: false, result: null };
    }

    onEmailVoucher = (email) => {
        const accnr = this.props.login && this.props.login.currentRole && this.props.login.currentRole.accnr;
        if (!accnr) {
            return; //not in business role
        }
        if (this.state.isLoaderVisible) {
            return;
        }
        this.setState({ isLoaderVisible: true }, () => {
            this.props.vouchersRequest(
                {
                    "requestType": "emailVoucher",
                    "userId": this.props.login.privateClientData.userId,
                    "token": this.props.login.token,
                    "voucherNr": this.props.voucherNr,
                    "email": email
                },
                data => {
                    const _accnr = this.props.login && this.props.login.currentRole && this.props.login.currentRole.accnr;
                    if (!_accnr || _accnr !== accnr) {
                        return; //role changed
                    }
                    this.setState({
                        result: data.records.result,
                        isDone: data.records.statusCode === 200,
                        isError: data.records.statusCode !== 200,
                        isLoaderVisible: false
                    });
                }, error => {
                    this.setState({ isLoaderVisible: false });
                });
        });
    }

    onEmailChange = (e) => {
        this.setState({ email: e.target.value });
    }

    render() {
        return (
            <Modal {...{
                title: this.props.translation.title,
                onCloseButtonClick: this.props.onModalClose,
                content:
                    <ModalInputText {...{
                        text: this.props.translation.emailField,
                        id: "email",
                        value: this.state.email,
                        onChange: this.onEmailChange
                    }} />,
                isSaveButton: true,
                onActionButtonClick: () => this.onEmailVoucher(this.state.email),
                actionButtonTitle: this.props.translation.sendButton,
                isLoaderVisible: this.state.isLoaderVisible,
                isDone: this.state.isDone,
                isError: this.state.isError,
                result: this.state.result,
                height: 112
            }} />
        )
    }
});

const AttachVoucher = connect(state => ({ translation: state.translation.vouchers.attach }))(class extends PureComponent {
    constructor(props) {
        super(props);
        this.state = { isLoaderVisible: false, isDone: false, isError: false, result: null };
    }

    onAttach = () => {
        const userId = this.props.login && this.props.login.privateClientData && this.props.login.privateClientData.userId;
        if (!userId || this.state.isLoaderVisible) {
            return;
        }
        this.setState({ isLoaderVisible: true }, () => {
            this.props.vouchersRequest(
                {
                    "requestType": "attachVoucher",
                    "userId": userId,
                    "token": this.props.login.token,
                    "voucherNr": this.props.voucherNr,
                    "ignoreErrorModal": true
                },
                data => {
                    this.setState({
                        result: this.props.translation.successText,
                        isDone: true,
                        isError: false,
                        isLoaderVisible: false
                    });
                }, data => {
                    // Non-200 responses (e.g. already attached / unavailable) come back here.
                    // Show the server's specific message instead of a generic failure, and
                    // treat "already on your account" as informational rather than an error.
                    const records = data && data.records;
                    const alreadyAttached = records && records.statusCode === 409;
                    this.setState({
                        result: (records && records.result) || this.props.translation.error,
                        isDone: alreadyAttached,
                        isError: !alreadyAttached,
                        isLoaderVisible: false
                    });
                });
        });
    }

    render() {
        return (
            <Modal {...{
                title: this.props.translation.title,
                onCloseButtonClick: this.props.onModalClose,
                content: (
                    <>
                        <ModalText text={`${this.props.comment} ${this.props.voucherValue}`} />
                        <ModalText text={this.props.translation.question} />
                    </>
                ),
                isSaveButton: true,
                onActionButtonClick: this.onAttach,
                actionButtonTitle: this.props.translation.confirmButton,
                isLoaderVisible: this.state.isLoaderVisible,
                isDone: this.state.isDone,
                isError: this.state.isError,
                result: this.state.result,
                height: 120
            }} />
        )
    }
});

class Vouchers extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isGiftCardsCollectionVisible: true,
            isVouchersCollectionVisible: true,
            vouchers: null,
            sharedVoucher: null,
            sharedVoucherNr: null,
            sharedComment: null,
            sharedValue: null,
            isShareLoaderVisible: false,
            shareError: false,
            shareErrorText: null
        };
    }

    openVoucherPdf = (voucherNr) => {
        const userId = this.props.login && this.props.login.currentRole && this.props.login.currentRole.userId;
        if (!userId) {
            return; //not in private role
        }
        window.open(`${url}&act=olerexweb.private.vouchers&requestType=printVoucher&token=${this.props.login.token}&userId=${userId}&voucherNr=${voucherNr}&pdf=1`);
    }

    downloadData = () => {
        if (this.props.login && this.props.login.privateClientData) {

            this.setState({ isLoaderVisible: true, shareError: false }, () => {
                this.props.vouchersRequest(
                    {
                        "requestType": "getVoucher",
                        "userId": this.props.login.privateClientData.userId,
                        "token": this.props.login.token,
                    },
                    data => {
                        const vouchers = data.records.voucherType ? data.records.voucherType.map(x => ({
                            ...x, vouchers: x.vouchers ? x.vouchers.map(y => ({
                                ...y,
                                onEmailButtonClick: () => this.props.onModalOpen(<EmailVoucher {...{
                                    onModalClose: this.props.onModalClose,
                                    vouchersRequest: this.props.vouchersRequest,
                                    login: this.props.login,
                                    voucherNr: y.voucherNr,
                                    email: this.props.login.privateClientData.email
                                }} />),
                                onPrintButtonClick: () => this.openVoucherPdf(y.voucherNr)
                            })) : null
                        })) : null;
                        this.setState({ isLoaderVisible: false, vouchers: vouchers });
                    }, error => {
                        this.setState({ isLoaderVisible: false });
                    });
            });
        }
    }

    getVoucher(voucherNr) {
        if (this.props.login && this.props.login.privateClientData) {

            this.setState({ isShareLoaderVisible: true, shareError: false, shareErrorText: null }, () => {
                this.props.vouchersRequest(
                    {
                        "requestType": "getShareVoucher",
                        "userId": this.props.login.privateClientData.userId,
                        "token": this.props.login.token,
                        "voucherNr": voucherNr,
                        "ignoreErrorModal": true
                    },
                    data => {
                        const sharedVoucher = data.records.voucher ? [{
                            "description": this.props.translation.sharedTitle,
                            "vouchers": [{
                            ...data.records.voucher,
                            onEmailButtonClick: () => this.props.onModalOpen(<EmailVoucher {...{
                                onModalClose: this.props.onModalClose,
                                vouchersRequest: this.props.vouchersRequest,
                                login: this.props.login,
                                voucherNr: data.records.voucher.voucherNr,
                                email: this.props.login.privateClientData.email
                            }} />),
                            onPrintButtonClick: () => this.openVoucherPdf(data.records.voucher.voucherNr)
                         }]
                        }] : null;
                        this.setState({
                            isShareLoaderVisible: false,
                            sharedVoucher: sharedVoucher,
                            sharedVoucherNr: data.records.voucher ? data.records.voucher.voucherNr : null,
                            sharedComment: data.records.voucher ? data.records.voucher.comment : null,
                            sharedValue: data.records.voucher ? data.records.voucher.voucherValue : null,
                            shareError: !sharedVoucher,
                            shareErrorText: !sharedVoucher ? (data.records && data.records.result) || null : null
                        });
                    }, error => {
                        // Non-200 (e.g. already on the account) lands here. Prefer the server's
                        // specific message over the generic "no longer available" fallback.
                        const records = error && error.records;
                        this.setState({
                            isShareLoaderVisible: false,
                            shareError: true,
                            shareErrorText: (records && records.result) || null
                        });
                    });
            });
        }
    }

    openAttachModal = () => {
        this.props.onModalOpen(<AttachVoucher {...{
            onModalClose: this.props.onModalClose,
            vouchersRequest: this.props.vouchersRequest,
            login: this.props.login,
            voucherNr: this.state.sharedVoucherNr,
            comment: this.state.sharedComment,
            voucherValue: this.state.sharedValue
        }} />);
    }

    componentDidMount() {
        var path = window.location.pathname.split("/");

        if (path[2]) {
            this.getVoucher(path[2]);
        } else {
            this.downloadData();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (roleOrLanguageChanged(prevProps, this.props)) {
            this.downloadData();
        }
    }

    renderSharedVoucher() {
        return (
            <div className="vouchers">
                <div className="vouchers-header-shadow"></div>
                <div className="vouchers-header">
                    <h1 className="vouchers-header-title">{this.props.translation.sharedTitle}</h1>
                </div>
                <TransitionGroup component={null}>
                    {this.state.isShareLoaderVisible && <CSSTransition key={"share-loader-fade"} timeout={{ enter: 250, exit: 250 }} classNames={"fast-fade"}>
                        <Loader className={"vouchers-loader"} />
                    </CSSTransition>}

                    {!this.state.isShareLoaderVisible && <CSSTransition key={"share-body-content"} timeout={{ enter: 250, exit: 250 }} classNames={"fast-fade"}>
                        <div className="vouchers-body">
                            {this.state.shareError &&
                                <NoContent {...{ text: this.state.shareErrorText || this.props.translation.shareUnavailable }} />}
                            {this.state.sharedVoucher &&
                                <div className="vouchers-body-content">
                                    {this.state.sharedVoucher.map((voucher, index) => <VouchersContent {...{
                                        ...voucher,
                                        key: index,
                                        isMobileLayout: this.props.isMobileLayout
                                    }} />)}
                                    <button className="vouchers-attach-button" onClick={this.openAttachModal}>
                                        {this.props.translation.attach.addButton}
                                    </button>
                                </div>}
                        </div>
                    </CSSTransition>}
                </TransitionGroup>
            </div>
        );
    }

    render() {
        if (this.state.sharedVoucher || this.state.shareError || this.state.isShareLoaderVisible) {
            return this.renderSharedVoucher();
        }

        const isNoContentVisible = this.state.vouchers === null;
        return (
            <div className="vouchers">
                <div className="vouchers-header-shadow"></div>
                <div className="vouchers-header">
                    <h1 className="vouchers-header-title">{this.props.translation.title}</h1>
                </div>
                <TransitionGroup component={null}>
                    {this.state.isLoaderVisible && <CSSTransition key={"loader-fade"} timeout={{ enter: 250, exit: 250 }} classNames={"fast-fade"}>
                        <Loader className={"vouchers-loader"} />
                    </CSSTransition>}

                    {!this.state.isLoaderVisible && <CSSTransition key={"body-content"} timeout={{ enter: 250, exit: 250 }} classNames={"fast-fade"}>
                        <div className="vouchers-body">
                            <TransitionGroup component={null}>
                                {isNoContentVisible &&
                                    <CSSTransition key={"no-content"} timeout={{ enter: 250, exit: 250 }} classNames={"fast-fade"}>
                                        <NoContent {...{ text: this.props.translation.noContent }} />
                                    </CSSTransition>}
                                {!isNoContentVisible &&
                                    <CSSTransition key={"content"} timeout={{ enter: 250, exit: 250 }} classNames={"fast-fade"}>
                                        <div className="vouchers-body-content">
                                            {this.state.vouchers && this.state.vouchers.map((voucher, index) => <VouchersContent {...{
                                                ...voucher,
                                                key: index,
                                                isMobileLayout: this.props.isMobileLayout
                                            }} />)}
                                        </div>
                                    </CSSTransition>}
                            </TransitionGroup>
                        </div>
                    </CSSTransition>}
                </TransitionGroup>
            </div>
        );
    }
}

export default connect(
    state => ({
        login: state.login,
        isMobileLayout: state.size.isMobileLayout,
        translation: state.translation.vouchers
    }),
    dispatch => ({ vouchersRequest: (body, success, error) => privateVouchersRequest(dispatch, body, success, error) }))(Vouchers);
